<template>
  <div>
    <span v-if="this.errors.size > 0">{{ this.errors[0] }}</span>


    <b-card :title="formTitle">
      <div v-for="error in errors" :key="error" :id="error">
        <b-alert show variant="danger">
          {{ error }}
        </b-alert>
      </div>

      <b-form @submit="submitOrganization">
        <b-form-group
          label="Name"
          description="The name of the organization"
          label-for="organization_name"
        >
          <b-form-input id="organization_name" type="text" v-model="organization.name"></b-form-input>
        </b-form-group>

        <b-button v-if="this.id === null" type="submit" variant="success">Create Organization</b-button>
        <b-button v-else type="submit" variant="info">Update Organization</b-button>
      </b-form>
    </b-card>
  </div>
</template>

<script>

import { OrganizationService } from '@/common/services/organization.service';

export default {
  name: 'OrganizationForm',
  components: {

  },
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      organization: {
        name: '',
      },
      errors: [],
    };
  },
  created() {
    if (this.id !== null) {
      this.getOrganization(this.id);
    }
  },
  methods: {
    submitOrganization(event) {
      event.preventDefault();
      if (this.id === null) {
        this.createOrganization();
      } else {
        this.updateOrganization();
      }
    },
    getOrganization(params) {
      OrganizationService.get(params).then((response) => {
        this.organization = response.data;
      });
    },
    createOrganization() {
      OrganizationService.create(this.organization)
      .then(({ data }) => {
        this.$emit('success', data.id);
      })
      .catch((err) => {
        console.warn(err.response.data.error);
        this.errors = err.response.data.error;
      });
    },
    updateOrganization() {
      OrganizationService.update(this.id, this.organization)
        .then(({ data }) => {
          this.$emit('success', data.id);
        }).catch((err) => {
          console.log(err)
          this.errors = err.response.data.error;
        });
    }
  },
  computed: {
    formTitle() {
      return this.id === null ? "Create Organization" : "Update Organization"
    }
  },
};

</script>

<style lang="scss" scoped>

</style>
